document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-zero-shop]').forEach(function (root) {
    var filtersWrap = root.querySelector('[data-zero-shop-filters]');
    var cards = root.querySelectorAll('[data-zero-card]');

    if (!filtersWrap) return;

    filtersWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-zero-filter]');
      if (!btn) return;

      filtersWrap.querySelectorAll('[data-zero-filter]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');

      var filter = btn.getAttribute('data-zero-filter');

      cards.forEach(function (card) {
        if (filter === 'all') {
          card.classList.remove('is-hidden');
          return;
        }
        var collections = (card.getAttribute('data-zero-collections') || '').split(' ');
        if (collections.indexOf(filter) !== -1) {
          card.classList.remove('is-hidden');
        } else {
          card.classList.add('is-hidden');
        }
      });
    });
  });
});